export { default, Rect } from "./Placeholder";
